module.exports = __webpack_public_path__ + "static/media/aside-bg-1.65b21b7e.png";